const combine = {
    'client.feeds.combine.combine': 'Combinable fields',
    'client.feeds.combine.draganddrop': 'Drag the fields to combine',

    'client.feeds.combine.message': 'Make sure price or purchase price is combined.',

    'client.feeds.combine.columns.name': 'Name',
    'client.feeds.combine.columns.manufacturer': 'Brand',
    'client.feeds.combine.columns.category': 'Category',
    'client.feeds.combine.columns.price': 'Price',
    'client.feeds.combine.columns.unique_code': 'Article number',
    'client.feeds.combine.columns.ean': 'EAN',
    'client.feeds.combine.columns.height': 'Height',
    'client.feeds.combine.columns.width': 'Width',
    'client.feeds.combine.columns.length': 'Length',
    'client.feeds.combine.columns.weight': 'Weight',
    'client.feeds.combine.columns.description': 'Description',
    'client.feeds.combine.columns.image': 'Image',
    'client.feeds.combine.columns.manufacturer_code': 'Brand article number',
    'client.feeds.combine.columns.order_number': 'Order number',
    'client.feeds.combine.columns.in_stock': 'In stock',
    'client.feeds.combine.columns.amount_in_stock': 'Quantity in stock',
    'client.feeds.combine.columns.tax_class_id': 'VAT class',
    'client.feeds.combine.columns.purchase_price': 'Purchase price',
    'client.feeds.combine.columns.regulation_price': 'Regular price',
    'client.feeds.combine.columns.variant': 'Variant',
    'client.feeds.combine.columns.related': 'Related',
    'client.feeds.combine.columns.cross_sell': 'Cross Sell\'s',
    'client.feeds.combine.columns.clearance_sale': 'Clearance sales',
    'client.feeds.combine.columns.restock_time': 'Restock time',
    'client.feeds.combine.columns.delivery_time': 'Delivery time',

    'clients.feeds.combine.columns.shopware_6_only': 'Shopware 6 only',

    'client.feeds.combine.columns.price-purchase': 'Price or Purchase price',

    'client.feeds.combine.complete': 'Save combinations',
    'client.feeds.combine.required': 'The `%field%` field must be linked for correct operation.',
};

export default combine;
